import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.map.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.search.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapGetters } from 'vuex';
import debounce from 'lodash/debounce';
import USE_MARKETPLACE from '~/const/marketplace';
import searchSuggestionQuery from '~/graphql/searchSuggestion.gql';
import searchSuggestionAlgoliaQuery from '~/graphql/searchSuggestionAlgolia.gql';
import SEARCH_PROVIDER from '~/helpers/search-data-helpers';
export default {
  props: {
    search: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      results: {},
      loading: false,
      timeout: 3000
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    provider: 'search/provider'
  })), {}, {
    getAlgoliaIndex: function getAlgoliaIndex() {
      var algolia = this.$store.state.sharedEnv.payload.algolia;
      return algolia;
    },
    isMarketplace: function isMarketplace() {
      return USE_MARKETPLACE(this);
    },
    isAlgoliaProvider: function isAlgoliaProvider() {
      return SEARCH_PROVIDER(this) === 'algolia';
    }
  }),
  watch: {
    immediate: true,
    search: function search() {
      if (this.search.length === 0) {
        this.results = {};
        return this.results;
      }
      this.debounceGetSuggestion();
    }
  },
  methods: {
    debounceGetSuggestion: debounce( /*#__PURE__*/function () {
      var _getSuggestions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getResults();
            case 2:
              this.$emit('results-received', this.results);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getSuggestions() {
        return _getSuggestions.apply(this, arguments);
      }
      return getSuggestions;
    }(), 200),
    getResults: function getResults() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, canRunSearch, controller, timeoutFallback;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(SEARCH_PROVIDER(_this) === 'algolia')) {
                _context2.next = 24;
                break;
              }
              canRunSearch = _this.search.length >= 3;
              _context2.prev = 2;
              if (!canRunSearch) {
                _context2.next = 13;
                break;
              }
              controller = new AbortController();
              timeoutFallback = setTimeout(function () {
                return controller.abort();
              }, _this.timeout);
              _context2.next = 8;
              return _this.getAlgoliaCorvusSuggestions();
            case 8:
              response = _context2.sent;
              _this.fallbackErrors(response, controller);
              clearTimeout(timeoutFallback);
              _this.results = response;
              return _context2.abrupt("return");
            case 13:
              _context2.next = 22;
              break;
            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](2);
              _context2.next = 19;
              return _this.getSuggestions();
            case 19:
              response = _context2.sent;
              _this.results = response;
              _this.$logger.error(_context2.t0);
            case 22:
              _context2.next = 28;
              break;
            case 24:
              _context2.next = 26;
              return _this.getSuggestions();
            case 26:
              response = _context2.sent;
              _this.results = response;
            case 28:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[2, 15]]);
      }))();
    },
    getAlgoliaCorvusSuggestions: function getAlgoliaCorvusSuggestions() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var algoliaUserToken, _yield$_this2$$apollo, _yield$_this2$$apollo2, ABTests, queryIDS, algoliaProducts, algoliaCategories, suggestions, algoliaSuggestProducts, totalProducts, queryID, provider, categories, total, products, indexedSuggestions, results;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              algoliaUserToken = _this2.$cookies.get('_ALGOLIA') || '';
              _this2.loading = true;
              _context3.prev = 2;
              _context3.next = 5;
              return _this2.$apolloProvider.defaultClient.query({
                query: searchSuggestionAlgoliaQuery,
                variables: {
                  locale: _this2.locale.iso,
                  keyword: _this2.search,
                  offset: 0,
                  sortBy: 'POPULAR',
                  orderBy: 'DEFAULT',
                  filterBy: [],
                  algoliaUserToken: algoliaUserToken,
                  withMarketplace: _this2.isMarketplace
                }
              });
            case 5:
              _yield$_this2$$apollo = _context3.sent;
              _yield$_this2$$apollo2 = _yield$_this2$$apollo.data.searchSuggestionsMultiQuery;
              ABTests = _yield$_this2$$apollo2.ABTests;
              queryIDS = _yield$_this2$$apollo2.queryIDS;
              algoliaProducts = _yield$_this2$$apollo2.products;
              algoliaCategories = _yield$_this2$$apollo2.categories;
              suggestions = _yield$_this2$$apollo2.suggestions;
              _this2.loading = false;
              algoliaSuggestProducts = algoliaProducts.products, totalProducts = algoliaProducts.total, queryID = algoliaProducts.queryID, provider = algoliaProducts.provider;
              categories = algoliaCategories.map(function (category, i) {
                return _objectSpread(_objectSpread({}, category), {}, {
                  position: i + 1
                });
              });
              total = algoliaSuggestProducts.length + categories.length;
              products = algoliaSuggestProducts.map(function (product, i) {
                return _objectSpread(_objectSpread({}, product), {}, {
                  position: i + 1
                });
              });
              indexedSuggestions = suggestions.map(function (suggestion, i) {
                return _objectSpread(_objectSpread({}, suggestion), {}, {
                  position: i + 1
                });
              });
              results = {
                ABTests: ABTests,
                query: _this2.search,
                queryIDS: queryIDS,
                // todo: delete queryID when queryIDS is used
                queryID: queryID,
                products: products,
                categories: categories,
                suggestions: indexedSuggestions,
                total: total,
                totalProducts: totalProducts,
                provider: provider
              };
              return _context3.abrupt("return", results);
            case 22:
              _context3.prev = 22;
              _context3.t0 = _context3["catch"](2);
              _this2.loading = false;
              _this2.$logger.error(_context3.t0);
            case 26:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[2, 22]]);
      }))();
    },
    getSuggestions: function getSuggestions() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$_this3$$apollo, _yield$_this3$$apollo2, categorySearch, productSearchSuggest, products, totalProducts, categories, total, results;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this3.loading = true;
              _context4.prev = 1;
              _context4.next = 4;
              return _this3.$apolloProvider.defaultClient.query({
                query: searchSuggestionQuery,
                variables: {
                  locale: _this3.locale.iso,
                  keyword: _this3.search,
                  offset: 0,
                  limit: 5,
                  sortBy: 'POPULAR',
                  orderBy: 'DEFAULT',
                  filterBy: []
                }
              });
            case 4:
              _yield$_this3$$apollo = _context4.sent;
              _yield$_this3$$apollo2 = _yield$_this3$$apollo.data;
              categorySearch = _yield$_this3$$apollo2.categorySearch;
              productSearchSuggest = _yield$_this3$$apollo2.productSearchSuggest;
              _this3.loading = false;
              products = productSearchSuggest.products, totalProducts = productSearchSuggest.total;
              categories = categorySearch;
              total = products.length + categories.length;
              results = {
                query: _this3.search,
                products: products,
                categories: categories,
                suggestions: [],
                total: total,
                totalProducts: totalProducts
              };
              return _context4.abrupt("return", results);
            case 16:
              _context4.prev = 16;
              _context4.t0 = _context4["catch"](1);
              _this3.loading = false;
              _this3.$logger.error(_context4.t0);
            case 20:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[1, 16]]);
      }))();
    },
    fallbackErrors: function fallbackErrors(response, controller) {
      if (!response) {
        throw new Error('Algolia has no response in SearchDataProvider.vue (line 51) : switch to elastic');
      }
      if (controller.signal && controller.signal.aborted) {
        throw new Error('Algolia response time is exceeded in SearchDataProvider.vue (line 51) : switch to elastic');
      }
    }
  },
  render: function render() {
    return this.$scopedSlots.default({
      keyword: this.search,
      data: this.results,
      loading: this.loading
    });
  }
};